import { formateBridgeParams } from '@/utils';

export const V5JSBridge = (window as any).V5JSBridge || {};

export default function () {
  return (options: Record<string, unknown>) => {
    console.log('jump  useRouterToNativeRouter======', options, V5JSBridge.routerToNativeRouter);
    V5JSBridge.routerToNativeRouter?.(formateBridgeParams(options));
  };
}

// 增加分享按钮
export function addShareAction(options: Record<string, unknown>) {
  V5JSBridge.addShareAction?.(formateBridgeParams(options));
}

// 移除分享按钮
export function removeShareAction() {
  V5JSBridge.removeShareAction?.();
}
